// 时间颗粒度(总览)
export enum OverviewDateType {
  MONTH = 'M',
  YEAR = 'Y',
}

export const OverviewDateTypeDisplay = {
  [OverviewDateType.MONTH]: '月',
  [OverviewDateType.YEAR]: '年',
};

// 时间颗粒度
export enum DateType {
  DAY = 'D',
  MONTH = 'M',
  YEAR = 'Y',
}

export const DateTypeDisplay = {
  [DateType.DAY]: '按日',
  [DateType.MONTH]: '按月',
  [DateType.YEAR]: '按年',
};

export const ColorMap = ['#52E7FF', '#16DD8E', '#2D8DFF', '#FFCB47', '#854ECA', '#ABD335'];
export const ColorRankMap = ['#FF4D4F70', '#FF6D2C70', '#FFCB4770'];

export enum TimeSlot {
  PEAK,
  SHARP,
  FLAT,
  VALLEY,
}

export const TimeSlotDisplay = {
  [TimeSlot.PEAK]: '尖',
  [TimeSlot.SHARP]: '峰',
  [TimeSlot.FLAT]: '平',
  [TimeSlot.VALLEY]: '谷',
};

export const gasConfigList = [
  { key: 'compressedAir', name: '压缩空气', color: '#FF4D4F', unit: 'm³' },
  { key: 'naturalGas', name: '天然气', color: '#FFCB47', unit: 'm³' },
  { key: 'oxygen', name: '液氧', color: '#2D8DFF', unit: 't' },
  { key: 'argon', name: '液氩', color: '#16DD8E', unit: 't' },
  { key: 'carbonDioxide', name: '二氧化碳', color: '#ABD335', unit: 't' },
];

export type configuredListData = {
  total?: number;
  plan?: number;
  planRatio?: number;
  cost?: number;
  costRatio?: number;
  hasConfig?: boolean;
};
